export default class AdminPharmacyReports {
  axiosIns = null
  jwtConfig = null

  constructor(axiosIns, jwtConfig) {
    this.axiosIns = axiosIns;
    this.jwtConfig = jwtConfig;
  }

  list(params) {
    return this.axiosIns.get(this.jwtConfig.main.adminPharmacyReportsRoute, {
      params
    })
  }

  getChart(params) {
    return this.axiosIns.get(`${this.jwtConfig.main.adminPharmacyReportsRoute}/chart`, {
      params
    })
  }

  export(params) {
    return this.axiosIns.get(`${this.jwtConfig.main.adminPharmacyReportsRoute}/export`, {
      params,
      responseType: "blob"
    })
  }
}
